import React from 'react';
import { Modal, Form, Input, Button } from 'antd';
import { Project } from '../../types/project';
import styled from 'styled-components';

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
  }
  
  .ant-modal-header {
    border-bottom: none;
    padding: 24px 24px 0;
  }
  
  .ant-modal-body {
    padding: 24px;
  }
  
  .ant-modal-close {
    top: 16px;
    right: 16px;
  }
  
  .ant-form-item-label {
    display: none;
  }
  
  .ant-input {
    font-size: 16px;
    padding: 8px 12px;
  }
  
  .ant-btn {
    height: 40px;
    font-size: 16px;
    border-radius: 6px;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
  
  .ant-btn {
    flex: 1;
  }
`;

interface CreateProjectModalProps {
  open: boolean;
  onCancel: () => void;
  onSubmit: (values: { projectName: string; description: string }) => Promise<void>;
  loading: boolean;
  projects: Project[];
}

const CreateProjectModal: React.FC<CreateProjectModalProps> = ({
  open,
  onCancel,
  onSubmit,
  loading,
  projects
}) => {
  const [form] = Form.useForm();

  return (
    <StyledModal
      title="创建新项目"
      open={open}
      onCancel={onCancel}
      footer={null}
      width={400}
      centered
    >
      <Form 
        form={form} 
        onFinish={(values) => onSubmit({ ...values, currentStage: 0 })} 
        layout="vertical"
        requiredMark={false}
      >
        <Form.Item
          name="projectName"
          rules={[
            { required: true, message: '请输入项目名称' },
            { min: 2, message: '项目名称至少2个字符' },
            { max: 50, message: '项目名称最多50个字符' },
            {
              validator: async (_, value) => {
                if (!value) return;
                const existingProject = projects.find(p => p.projectName === value);
                if (existingProject) {
                  throw new Error('项目名称已存在，请使用其他名称');
                }
              }
            }
          ]}
        >
          <Input placeholder="为你的新项目起个名字" />
        </Form.Item>
        <ButtonGroup>
          <Button onClick={onCancel}>返回</Button>
          <Button type="primary" htmlType="submit" loading={loading}>
            创建
          </Button>
        </ButtonGroup>
      </Form>
    </StyledModal>
  );
};

export default CreateProjectModal; 